"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 40px;\n  border: none;\n  outline: 0;\n  margin: 0;\n  padding: 0;\n  background: ", ";\n  text-indent: 12px;\n  font-family: ", ";\n  color: ", ";\n  font-size: 16px;\n  max-width: 400px;\n  box-sizing: border-box;\n  border: 1.5px solid transparent;\n\n  &:focus {\n    border: 1.5px solid ", ";\n    background: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background: ", ";\n    cursor: not-allowed;\n  }\n\n  &.invalid {\n    background: ", ";\n    border: 1.5px solid ", ";\n    color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  height: 40px;\n  border: none;\n  outline: 0;\n  margin: 0;\n  padding: 0;\n  background: ", ";\n  text-indent: 12px;\n  font-family: ", ";\n  color: ", ";\n  font-size: 16px;\n  max-width: 400px;\n  box-sizing: border-box;\n  border: 1.5px solid transparent;\n\n  &:focus {\n    border: 1.5px solid ", ";\n    background: ", ";\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background: ", ";\n    cursor: not-allowed;\n  }\n\n  &.invalid {\n    background: ", ";\n    border: 1.5px solid ", ";\n    color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map